import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UwButtonComponent } from './button.component';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        TranslateModule,
        UwButtonComponent,
    ],
    exports: [UwButtonComponent],
})
export class UwButtonModule {}
